import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/lib/site";
import { Reveal } from "./Reveal";

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="scroll-mt-24 py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">/ FAQ</p>
          <h2 className="mt-5 font-display text-4xl font-black tracking-tight sm:text-5xl">
            Perguntas frequentes
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12">
            {FAQS.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} className="border-b border-white/10">
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-medium sm:text-lg">{item.q}</span>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-violet-400 transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeOut" }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 text-sm leading-relaxed text-white/60 sm:text-base">
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
